module.exports = __webpack_public_path__ + "static/logo-966780034a11e0b41689014431e2dfd5.svg";